import { render, staticRenderFns } from "./DeliveryPointHistory.vue?vue&type=template&id=9eb4afa2"
import script from "./DeliveryPointHistory.vue?vue&type=script&lang=js"
export * from "./DeliveryPointHistory.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPointHistory.vue?vue&type=style&index=0&id=9eb4afa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports